// extracted by mini-css-extract-plugin
export default {"unboxed-item__info":"unboxed-item__info--208504","unboxedItem__info":"unboxed-item__info--208504"};